import { render, staticRenderFns } from "./SidebarLoader.vue?vue&type=template&id=7649cc28&scoped=true"
import script from "./SidebarLoader.vue?vue&type=script&lang=ts"
export * from "./SidebarLoader.vue?vue&type=script&lang=ts"
import style0 from "./SidebarLoader.vue?vue&type=style&index=0&id=7649cc28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649cc28",
  null
  
)

export default component.exports